import React, { useEffect, useState } from "react";
import Avatar from "./AvatarP";
import { useDispatch, useSelector } from "react-redux";
import { showPopup, setUserToken } from "../../redux/actions";
import { currentUser, isAuthenticated, getFileUrl, logout as pbLogout } from "../../auth/authApi";
import SvgIcn from "../../data/IconCompo";
import { useNavigate } from "react-router-dom";
import pb from "../../services/pocketbase";

function RightBarNav({}) {
  const userToken = useSelector((state) => state.userToken);
  const [userData, setUserData] = useState();
  const [image, setImage] = useState();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const syncUserFromAuth = () => {
    const user = currentUser();
    if (isAuthenticated() && user) {
      setUserData(user);
    } else {
      setUserData(undefined);
    }
  };

  const handleAvatarClick = () => {
    const user = currentUser();
    if (!isAuthenticated() || !user) {
      dispatch(showPopup("login"));
      return;
    }
    const slug =
      (user.username && String(user.username).trim()) ||
      (user.email && String(user.email).split("@")[0]) ||
      "";
    if (!slug) {
      dispatch(showPopup("login"));
      return;
    }
    navigate(`/${encodeURIComponent(slug)}`);
  };

  useEffect(() => {
    syncUserFromAuth();
    const unsub = pb.authStore.onChange(() => {
      syncUserFromAuth();
    }, true);
    return () => unsub();
  }, [userToken]);

  useEffect(() => {
    if (userData) {
      const url = getFileUrl(userData, userData?.avatar);
      setImage(url || undefined);
    }
  }, [userData]);
  return (
    <div className="right-bar-hero">
      <div className="avatar-hero" onClick={handleAvatarClick}>
        <Avatar imageUrl={image} />
      </div>
      {isAuthenticated() && (
        <div className="right-bar-icon-box"
          onClick={() => {
            window.location = `/setting`;
          }}
        >
          <SvgIcn name="setting_b" className="right-bar-icon" />
        </div>
      )}
      {/* {isAuthenticated() && (
        <div
          className="right-bar-icon-box"
          onClick={() => {
            pbLogout();
            dispatch(setUserToken(false));
            window.location.reload();
          }}
        >
          <SvgIcn name="logout" className="right-bar-icon" />
        </div>
      )} */}
     
     <div className="icons-box">
     <div className="right-bar-icon-box"
          onClick={() => { dispatch(showPopup("contact"));}}
        >
          <SvgIcn name="mail" className="right-bar-icon" />
        </div> 

        <div className="right-bar-icon-box"
          onClick={() => dispatch(showPopup("about"))}
        >
          <SvgIcn name="uud_icon" className="right-bar-icon" />
        </div>      
    
        <div className="right-bar-icon-box"
          onClick={() => { dispatch(showPopup("policy"));}}
        >
          <SvgIcn name="Policy" className="right-bar-icon" />
        </div>      

         <div className="copyright">
         ©UUD 2026
        </div>      
        </div>
    </div>
  );
}

export default RightBarNav;
